module.exports = require("babel-polyfill");


//////////////////
// WEBPACK FOOTER
// external "babel-polyfill"
// module id = 2
// module chunks = 0